import React from 'react';

interface ModalContextType {
  openModalCount: number;
}

export const ModalContext = React.createContext<ModalContextType>({ openModalCount: 0 });
